import _Object$keys from '/d02/applications/www/frontend/cashback.wmr.ru/releases/232/node_modules/babel-runtime/core-js/object/keys';
import _Promise from '/d02/applications/www/frontend/cashback.wmr.ru/releases/232/node_modules/babel-runtime/core-js/promise';
import _Object$assign from '/d02/applications/www/frontend/cashback.wmr.ru/releases/232/node_modules/babel-runtime/core-js/object/assign';
import Vuex from 'vuex';
import axios from '~/plugins/axios';

var roles = {
  admin: {
    statistic: {
      itemAccess: true,
      all: true,
      byRegister: true,
      byLinks: true,
      byOffers: true,
      byMoney: true,
      byTime: true,
      byTurn: true,
      oldStuff: true,
      compensation: true,
      utm: true,
      autocompensation: true,
      byOrders: true
    },
    shops: {
      itemAccess: true,
      list: true,
      add: true,
      categories: true,
      cpaCategories: true
    },
    projects: {
      itemAccess: true,
      list: true,
      add: true
    },
    users: {
      itemAccess: true,
      admins: true,
      resellers: true,
      list: true
    },
    finances: {
      itemAccess: true,
      moderate: true,
      approved: true,
      history: true,
      corrects: true
    },
    orders: {
      itemAccess: true,
      list: true
    },
    cpa: {
      itemAccess: true,
      moderate: true,
      list: true
    },
    feedbacks: {
      itemAccess: true,
      moderate: true,
      published: true,
      list: true
    },
    news: {
      itemAccess: true,
      list: true,
      add: true
    },
    promotional: {
      itemAccess: true,
      list: true
    },
    mails: {
      itemAccess: true,
      list: true,
      push: true,
      news: true
    },
    tickets: {
      itemAccess: true,
      list: true,
      fromPartners: true,
      my: true
    },
    settings: {
      itemAccess: true,
      templates: true,
      messages: true,
      tickets: true,
      statuses: true,
      payment_systems: true,
      currency: true,
      cpa: true
    },
    logs: {
      itemAccess: true,
      node: true,
      stat: true
    },
    system: {
      itemAccess: true,
      sync: true,
      migrations: true,
      test: true
    }
  },
  partner: {
    statistic: {
      itemAccess: true,
      byRegister: true,
      byLinks: true,
      byMoney: true,
      compensation: true,
      byOrders: true
    },
    shops: {
      itemAccess: true,
      list: true
    },
    users: {
      itemAccess: true,
      list: true
    },
    finances: {
      itemAccess: true,
      moderate: true,
      history: true
    },
    orders: {
      itemAccess: true,
      list: true
    },
    feedbacks: {
      itemAccess: true,
      moderate: true,
      published: true,
      list: true
    },
    news: {
      itemAccess: true,
      list: true,
      add: true
    },
    promotional: {
      itemAccess: true,
      list: true,
      add: true
    },
    mails: {
      itemAccess: true,
      list: true,
      add: true,
      listAuto: true,
      addAuto: true,
      push: true,
      news: true
    },
    tickets: {
      itemAccess: true,
      list: true,
      my: true,
      fromAdmins: true
    },
    settings: {
      itemAccess: true,
      rules_templates: true
    },
    faq: true
  },
  supportAgent: {
    support: true
  }
};

var objMatchRoles = {
  1: 'admin',
  2: 'admin',
  3: 'partner',
  7: 'supportAgent'
};

var store = function store() {
  return new Vuex.Store({
    state: {
      authUser: null,
      guestToken: false,
      userProfile: {
        id: null,
        avatar: null,
        groups: []
      },
      balance: {
        holded: { RUB: 0, EUR: 0, USD: 0, UAH: 0 },
        approved: { RUB: 0, EUR: 0, USD: 0, UAH: 0 }
      },
      access: {
        statistic: {
          itemAccess: false,
          all: false,
          byRegister: false,
          byLinks: false,
          byOffers: false,
          byMoney: false,
          byTime: false,
          byTurn: false,
          oldStuff: false,
          compensation: false,
          utm: false,
          autocompensation: false,
          byOrders: false
        },
        shops: {
          itemAccess: false,
          list: false,
          add: false,
          categories: false,
          cpaCategories: false
        },
        projects: {
          itemAccess: false,
          list: false,
          add: false
        },
        users: {
          itemAccess: false,
          admins: false,
          resellers: false,
          list: false
        },
        finances: {
          itemAccess: false,
          moderate: false,
          approved: false,
          history: false,
          corrects: false
        },
        orders: {
          itemAccess: false,
          list: false
        },
        cpa: {
          itemAccess: false,
          moderate: false,
          list: false
        },
        feedbacks: {
          itemAccess: false,
          moderate: false,
          published: false,
          list: false
        },
        news: {
          itemAccess: false,
          list: false,
          add: false
        },
        promotional: {
          itemAccess: false,
          list: false,
          add: false
        },
        mails: {
          itemAccess: false,
          list: false,
          add: false,
          listAuto: false,
          addAuto: false,
          templates: false,
          push: false,
          news: false
        },
        tickets: {
          itemAccess: false,
          list: false,
          fromPartners: false,
          my: false,
          fromAdmins: false
        },
        settings: {
          itemAccess: false,
          templates: false,
          messages: false,
          tickets: false,
          statuses: false,
          payment_systems: false,
          currency: false,
          cpa: false,
          rules_templates: false
        },
        logs: {
          itemAccess: false,
          node: false,
          stat: false
        },
        system: {
          itemAccess: false,
          sync: false,
          migrations: false,
          test: false
        },
        support: false,
        faq: false
      },
      counters: {
        'tickets-from-users': 0,
        'tickets-from-resellers': 0,
        'tickets-my': 0,
        'orders-to-approve': 0,
        'orders-to-process': 0,
        'cpa-sources-wait': 0
      }
    },
    mutations: {
      SET_AUTH: function SET_AUTH(state, user) {
        state.authUser = user || null;
      },
      SET_GUEST: function SET_GUEST(state, token) {
        state.guestToken = token || false;
      },
      SET_UCOUNTER: function SET_UCOUNTER(state, counter) {
        state.counters['tickets-from-users'] = counter || 0;
      },
      SET_RCOUNTER: function SET_RCOUNTER(state, counter) {
        state.counters['tickets-from-resellers'] = counter || 0;
      },
      SET_MCOUNTER: function SET_MCOUNTER(state, counter) {
        state.counters['tickets-my'] = counter || 0;
      },
      SET_PCOUNTER: function SET_PCOUNTER(state, counter) {
        state.counters['orders-to-approve'] = counter || 0;
      },
      SET_PCOUNTER2: function SET_PCOUNTER2(state, counter) {
        state.counters['orders-to-process'] = counter || 0;
      },
      SET_CPA_WAIT_COUNTER: function SET_CPA_WAIT_COUNTER(state, counter) {
        state.counters['cpa-sources-wait'] = counter || 0;
      },
      SET_PROFILE: function SET_PROFILE(state, object) {
        state.userProfile = object || { id: null, avatar: null, groups: [] };
      },
      SET_BALANCE: function SET_BALANCE(state, object) {
        state.balance = object || { holded: { RUB: 0, EUR: 0, USD: 0, UAH: 0 }, approved: { RUB: 0, EUR: 0, USD: 0, UAH: 0 } };
      },
      SET_MRULES: function SET_MRULES(state, rules) {
        if (rules && rules.length > 0) {
          _Object$assign(state.access, roles[objMatchRoles[rules[0]]]);
        }
      }
    },
    actions: {
      nuxtServerInit: function nuxtServerInit(_ref, _ref2) {
        var commit = _ref.commit,
            dispatch = _ref.dispatch,
            getters = _ref.getters;
        var req = _ref2.req,
            redirect = _ref2.redirect,
            query = _ref2.query,
            route = _ref2.route;

        if (route.path !== '/refused') {
          var token = void 0;
          if ((getters.isAuth === null || getters.isAuth === false) && req.session.authUser !== undefined && req.session.authUser.token !== undefined && req.session.authUser.token !== null) {
            if (req.session.authUser !== undefined && req.session.authUser.guest !== undefined && req.session.authUser.guest !== null) {
              token = req.session.authUser.guest;
              commit('SET_GUEST', token);
            } else {
              token = req.session.authUser.token;
            }
          } else if (route.path !== '/sign/in' || route.path !== '/sign/out' || route.path !== '/refused') {
            redirect('/sign/in');
          }
          commit('SET_AUTH', token);
          if (getters.userId === null) {
            return new _Promise(function (resolve, reject) {
              if (req.session && req.session.authUser) {
                commit('SET_AUTH', token);
                return _Promise.all([dispatch('updateProfile', { token: token, isServer: true })]).then(function (groups) {
                  var promiseList = [];

                  var check = false;
                  for (var i = 0; i < groups[0].length; i++) {
                    if ([1, 2, 3, 4, 6].indexOf(groups[0][i]) !== -1) {
                      check = true;
                    }
                  }

                  if (!check || groups[0].length === 0) {
                    commit('SET_AUTH', null);
                    commit('SET_GUEST', null);
                    axios.post(process.env.NOSSL + '/api/logout', {}).then(function () {
                      redirect('/sign/in');
                    });
                  }
                  if (groups[0].indexOf(1) !== -1 || groups[0].indexOf(2) !== -1) {
                    promiseList.push(dispatch('updateAdminTicketsCounter', { token: token, isServer: true }));
                    promiseList.push(dispatch('updateAdminOrdersCounter', { token: token, isServer: true }));
                    promiseList.push(dispatch('updateAdminOrdersProcessCounter', { token: token, isServer: true }));
                    promiseList.push(dispatch('updateAdminBalance', { token: token, isServer: true }));
                    promiseList.push(dispatch('updateAdminCpaSourcesWaitCounter', { token: token, isServer: true }));
                  }
                  if (groups[0].indexOf(3) !== -1) {
                    promiseList.push(dispatch('updateResellerBalance', { token: token, isServer: true }));
                    promiseList.push(dispatch('updateResellerTicketsCounter', { token: token, isServer: true }));
                  }
                  if (groups[0].indexOf(7) !== -1) {
                    promiseList.push(dispatch('updateSupportTicketsCounter', { token: token, isServer: true }));
                  }
                  if (promiseList.length > 0) {
                    return _Promise.all(promiseList).then(function (res2) {
                      resolve(true);
                    });
                  } else {
                    resolve(true);
                  }
                }).catch(function (e) {
                  redirect('/refused');
                });
              } else {
                resolve(true);
              }
            }).catch(function (e) {
              redirect('/refused');
            });
          }
        }
      },
      tokenFirstInit: function tokenFirstInit(_ref3, token) {
        var commit = _ref3.commit,
            dispatch = _ref3.dispatch;

        return new _Promise(function (resolve, reject) {
          commit('SET_AUTH', token);
          dispatch('updateProfile', { token: token, isServer: false }).then(function (groups) {
            var promiseList = [];

            if (![1, 2, 3, 4, 6].includes(groups[0]) || groups.length === 0) {
              commit('SET_AUTH', null);
              commit('SET_GUEST', null);
              axios.post(process.env.AJAX + '/api/logout', {}).then(function () {
                document.location.href = '/sign/in';
                resolve('logout');
              });
            }
            if (groups.includes(1) || groups.includes(2)) {
              promiseList.push(dispatch('updateAdminTicketsCounter', { token: token, isServer: false }));
              promiseList.push(dispatch('updateAdminOrdersCounter', { token: token, isServer: false }));
              promiseList.push(dispatch('updateAdminOrdersProcessCounter', { token: token, isServer: false }));
              promiseList.push(dispatch('updateAdminBalance', { token: token, isServer: false }));
              promiseList.push(dispatch('updateAdminCpaSourcesWaitCounter', { token: token, isServer: true }));
            }
            if (groups.includes(3)) {
              promiseList.push(dispatch('updateResellerBalance', { token: token, isServer: false }));
              promiseList.push(dispatch('updateResellerTicketsCounter', { token: token, isServer: false }));
            }
            if (groups.includes(7)) {
              promiseList.push(dispatch('updateSupportTicketsCounter', { token: token, isServer: false }));
            }
            _Promise.all(promiseList).then(function (res2) {
              resolve(res2);
            });
          }).catch(function (e) {
            reject(e);
          });
        });
      },
      updateGuestToken: function updateGuestToken(_ref4, token) {
        var commit = _ref4.commit;

        commit('SET_GUEST', token);
      },
      updateProfile: function updateProfile(_ref5, req) {
        var commit = _ref5.commit;

        return new _Promise(function (resolve, reject) {
          var data = req.token ? { token: req.token } : {};
          var vUrl = req.isServer ? process.env.NOSSL : process.env.AJAX;

          // console.log('req.token: ', req)
          axios.post(vUrl + '/api/get', { data: { module: 'user-public', action: 'getProfile', data: data } }).then(function (res) {
            var groups = [];
            if (res.data.message.groups) {
              groups = _Object$keys(res.data.message.groups).map(function (item) {
                return res.data.message.groups[item].id;
              });
              commit('SET_MRULES', groups);
            }
            commit('SET_PROFILE', res.data.message);
            resolve(groups);
          }).catch(function (e) {
            console.warn(e);
            reject(e);
          });
        });
      },
      updateAdminBalance: function updateAdminBalance(_ref6, req) {
        var commit = _ref6.commit;

        return new _Promise(function (resolve, reject) {
          var data = req.token ? { token: req.token } : {};
          var vUrl = req.isServer ? process.env.NOSSL : process.env.AJAX;

          axios.post(vUrl + '/api/get', { data: { module: 'finance', action: 'getBalance', data: data } }).then(function (res) {
            var balance = {
              approved: res.data.message.approved || { RUB: 0, EUR: 0, USD: 0, UAH: 0 },
              holded: res.data.message.hold || { RUB: 0, EUR: 0, USD: 0, UAH: 0 }
            };
            commit('SET_BALANCE', balance);
            resolve(true);
          }).catch(function (e) {
            console.warn(e);
            resolve(true);
          });
        });
      },
      updateResellerBalance: function updateResellerBalance(_ref7, req) {
        var commit = _ref7.commit;

        return new _Promise(function (resolve, reject) {
          var data = req.token ? { token: req.token } : {};
          var vUrl = req.isServer ? process.env.NOSSL : process.env.AJAX;

          axios.post(vUrl + '/api/get', { data: { module: 'reseller-finance-public', action: 'getBalance', data: data } }).then(function (res) {
            var balance = {
              approved: res.data.message.approved || { RUB: 0, EUR: 0, USD: 0, UAH: 0 },
              holded: res.data.message.hold || { RUB: 0, EUR: 0, USD: 0, UAH: 0 }
            };
            commit('SET_BALANCE', balance);
            resolve(true);
          }).catch(function (e) {
            console.warn(e);
            resolve(true);
          });
        });
      },
      updateAdminTicketsCounter: function updateAdminTicketsCounter(_ref8, req) {
        var commit = _ref8.commit;

        return new _Promise(function (resolve, reject) {
          var data = req.token ? { token: req.token } : {};
          var vUrl = req.isServer ? process.env.NOSSL : process.env.AJAX;

          axios.post(vUrl + '/api/get', { data: { module: 'tickets', action: 'getCounters', data: data } }).then(function (res) {
            if (res.data.message && res.data.message.counters) {
              if (res.data.message.counters.users) {
                commit('SET_UCOUNTER', res.data.message.counters.users);
              }
              if (res.data.message.counters.resellers) {
                commit('SET_RCOUNTER', res.data.message.counters.resellers);
              }
              if (res.data.message.counters.my) {
                commit('SET_MCOUNTER', res.data.message.counters.my);
              }
            }
            resolve(true);
          }).catch(function (e) {
            console.warn(e);
            resolve(true);
          });
        });
      },
      updateResellerTicketsCounter: function updateResellerTicketsCounter(_ref9, req) {
        var commit = _ref9.commit;

        return new _Promise(function (resolve, reject) {
          var data = req.token ? { token: req.token } : {};
          var vUrl = req.isServer ? process.env.NOSSL : process.env.AJAX;

          axios.post(vUrl + '/api/get', { data: { module: 'reseller-tickets-public', action: 'getCounters', data: data } }).then(function (res) {
            if (res.data.message && res.data.message.counters) {
              if (res.data.message.counters.users) {
                commit('SET_UCOUNTER', res.data.message.counters.users);
              }
              if (res.data.message.counters.reseller) {
                commit('SET_RCOUNTER', res.data.message.counters.reseller);
              }
              if (res.data.message.counters.my) {
                commit('SET_MCOUNTER', res.data.message.counters.my);
              }
            }
            resolve(true);
          }).catch(function (e) {
            console.warn(e);
            resolve(true);
          });
        });
      },
      updateSupportTicketsCounter: function updateSupportTicketsCounter(_ref10, req) {
        var commit = _ref10.commit;

        return new _Promise(function (resolve, reject) {
          var data = req.token ? { token: req.token } : {};
          var vUrl = req.isServer ? process.env.NOSSL : process.env.AJAX;

          axios.post(vUrl + '/api/get', { data: { module: 'reseller-support', action: 'getCounters', data: data } }).then(function (res) {
            if (res.data.message && res.data.message.counters && res.data.message.counters.users) {
              commit('SET_UCOUNTER', res.data.message.counters.users);
            }
            resolve(true);
          }).catch(function (e) {
            console.warn(e);
            resolve(true);
          });
        });
      },
      updateAdminOrdersCounter: function updateAdminOrdersCounter(_ref11, req) {
        var commit = _ref11.commit;

        return new _Promise(function (resolve, reject) {
          var data = req.token ? { token: req.token } : {};
          var vUrl = req.isServer ? process.env.NOSSL : process.env.AJAX;

          axios.post(vUrl + '/api/get', { data: { module: 'withdraws', action: 'countWds', data: data } }).then(function (res) {
            if (res.data.message) {
              commit('SET_PCOUNTER', res.data.message);
            }
            resolve(true);
          }).catch(function (e) {
            console.warn(e);
            resolve(true);
          });
        });
      },
      updateAdminOrdersProcessCounter: function updateAdminOrdersProcessCounter(_ref12, req) {
        var commit = _ref12.commit;

        return new _Promise(function (resolve, reject) {
          var data = req.token ? { token: req.token } : {};
          var vUrl = req.isServer ? process.env.NOSSL : process.env.AJAX;

          axios.post(vUrl + '/api/get', { data: { module: 'withdraws', action: 'countWdsToApprove', data: data } }).then(function (res) {
            if (res.data.message) {
              commit('SET_PCOUNTER2', res.data.message);
            }
            resolve(true);
          }).catch(function (e) {
            console.warn(e);
            resolve(true);
          });
        });
      },
      updateAdminCpaSourcesWaitCounter: function updateAdminCpaSourcesWaitCounter(_ref13, req) {
        var commit = _ref13.commit;

        return new _Promise(function (resolve, reject) {
          var vUrl = req.isServer ? process.env.NOSSL : process.env.AJAX;
          var data = {
            search: {
              status: 'wait'
            },
            token: req.token || ''
          };
          return axios.post(vUrl + '/api/get', { data: { module: 'cpa-sources', action: 'getCounter', data: data } }).then(function (res) {
            if (res.data.message) {
              commit('SET_CPA_WAIT_COUNTER', res.data.message);
            }
            resolve(true);
          }).catch(function (e) {
            console.warn(e);
            resolve(true);
          });
        });
      }
    },
    getters: {
      isAuth: function isAuth(state) {
        return state.authUser;
      },
      projectId: function projectId(state) {
        return state.userProfile.project || state.userProfile.registeredBy;
      },
      guestToken: function guestToken(state) {
        return state.guestToken;
      },
      accessRights: function accessRights(state) {
        return state.access;
      },
      userProfile: function userProfile(state) {
        return state.userProfile;
      },
      userGroups: function userGroups(state) {
        return _Object$keys(state.userProfile.groups).map(function (item) {
          return state.userProfile.groups[item].id;
        });
      },
      userRole: function userRole(state) {
        return objMatchRoles[_Object$keys(state.userProfile.groups).find(function (group) {
          return state.userProfile.groups[group].id;
        })];
      },
      userBalance: function userBalance(state) {
        return state.balance;
      },
      userAvatar: function userAvatar(state) {
        return state.userProfile.avatar;
      },
      userId: function userId(state) {
        return state.userProfile.id;
      },
      userCounters: function userCounters(state) {
        return state.counters['tickets-from-users'];
      },
      resellerCounters: function resellerCounters(state) {
        return state.counters['tickets-from-resellers'];
      },
      myCounters: function myCounters(state) {
        return state.counters['tickets-my'];
      },
      payCounters: function payCounters(state) {
        return state.counters['orders-to-approve'];
      },
      processCounters: function processCounters(state) {
        return state.counters['orders-to-process'];
      },
      cpaWaitCounter: function cpaWaitCounter(state) {
        return state.counters['cpa-sources-wait'];
      }
    }
  });
};
export default store;


//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = ./store/index.js
// module chunks = 152